import theme from 'src/shared/theme';
import styled, { css } from 'styled-components';

export const tint = (hex: string, amount: number) => {
    let R = parseInt(hex.substring(1, 3), 16);
    let G = parseInt(hex.substring(3, 5), 16);
    let B = parseInt(hex.substring(5, 7), 16);

    const getSingle = (number: number) => parseInt(((number * (100 + amount)) / 100).toFixed(0));

    R = getSingle(R);
    G = getSingle(G);
    B = getSingle(B);

    R = R < 255 ? R : 255;
    G = G < 255 ? G : 255;
    B = B < 255 ? B : 255;

    const getDouble = (number: number) => (number.toString(16).length === 1 ? `0${number.toString(16)}` : number.toString(16));

    const RR = getDouble(R);
    const GG = getDouble(G);
    const BB = getDouble(B);

    return `#${RR}${GG}${BB}`;
};

export const Main = styled.nav`
    /* height: 100%; */
    /*width: 100%; */

    height: calc(100% - 55px);
    width: 295px;

    background-color: ${theme.app.backgroundColor};

    display: flex;
    flex: 1;
    flex-direction: column;

    position: fixed;
    top: 55px;
    overflow-y: hidden;
    z-index: 18;
`;

//-------------------------------------------
export const Header = styled.div`
    /* height: 55px;
	padding-bottom: 30px;
	padding-left: 8px; */

    > svg {
        height: 55px;
    }
`;

export const HeaderMenu = styled.div`
    position: relative;
`;

export const Body = styled.div`
    display: flex;
    flex: 1px;
    min-height: 0;
`;

//-------------------------------------------
export const ContainerLeft = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    min-width: 0;
    background-color: white;
`;

export const ContainerRight = styled.nav<{ $numOfShadow: number }>`
    /* Per togliere il bordino */
    border-left: ${(props) => (props.$numOfShadow == 0 ? `solid 2px ${theme.app.secondary_dark}` : null)};

    background-color: ${(props) => tint(theme.app.backgroundColor, props.$numOfShadow * -4)};
`;

//-------------------------------------------
export const ContainerLeftTop = styled.nav`
    width: 250px;
    flex: 1;
    overflow-y: auto;
    min-height: 0;
    position: relative;
    padding: 15px 0px;

    ::-webkit-scrollbar {
        width: 3px;
    }
    ::-webkit-scrollbar-track {
        background: ${theme.app.backgroundColor};
        border-radius: 20px;
    }
    ::-webkit-scrollbar-thumb {
        background: ${theme.app.secondary}; /* theme.app.secondBackgroundColor*/
        border-radius: 20px;
    }

    scrollbar-color: ${theme.app.secondary} ${theme.app.backgroundColor};
    scrollbar-width: thin;
`;

export const ContainerLeftBottom = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: end;
    padding: 0 25px;
`;

//-------------------------------------------
export const NavbarBottom = styled.nav`
    color: ${theme.app.primary};
    font-weight: ${theme.font.semi_bold};
    font-size: 14px;

    padding-top: 30px;
`;

export const Trial = styled.div<{ $isTrial: boolean }>`
    color: ${theme.app.primary};
    font-weight: ${theme.font.semi_bold};
    font-size: 12px;
    display: flex;
`;

//-------------------------------------------
export const NavbarContainer = styled.div`
    position: relative;
`;

export const Navbar = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    list-style-type: none;
    padding-inline-start: 1px;
    display: flex;
    flex-direction: column;
    gap: 1px;
    height: 100%;
    background: white;
    margin: 0;

    &.transition-enter {
        opacity: 0.01;
        transform: translate(-150px, 0);
    }

    &.transition-enter-active {
        opacity: 1;
        transform: translate(0, 0);
        transition: all 300ms ease-out;
    }

    &.transition-exit {
        opacity: 1;
        transform: translate(0, 0);
    }

    &.transition-exit-active {
        opacity: 0.01;
        transform: translate(150px, 0);
        transition: all 300ms ease-out;
    }
`;

export const NavbarUlSmall = styled.ul`
    list-style-type: none;
    padding: 0px;
    margin: 0px;
    display: flex;
    flex: 1;
    flex-direction: column;
`;

export const NavbarUlBottom = styled(NavbarContainer)``;

//-------------------------------------------
export const NavbarLi = styled.li<{ $isVisible: boolean }>`
    position: relative;
    ${(props) => (props.$isVisible ? null : 'display: none')};

    :hover {
        filter: alpha(opacity=70);
        opacity: 0.7;
    }
`;

export const NavbarLiBottom = styled.li`
    position: relative;
`;

export const NavbarLiSmall = styled.li<{ $numOfShadow: number }>`
    background-color: ${(props) => tint(theme.app.backgroundColor, props.$numOfShadow * -4)};
`;

export const Linkcss = css`
    padding: 5px;
    margin: 2px;
    display: flex;
    align-items: center;
    justify-content: left;
    text-decoration: none;
    cursor: pointer;
    color: black;
`;

//-----------------------------------------------
export const LinkSidebar = styled.a<{ $isHeader?: boolean }>`
    /* height: 25px; */
    ${Linkcss}
    ${(props) => (props.$isHeader ? `font-weight: ${theme.font.black};` : `font-weight: ${theme.font.regular};`)};
    ${(props) => (props.$isHeader ? `font-size: 14px;` : `font-size: 13px;`)};
    ${(props) => (props.$isHeader ? `text-transform: uppercase;` : null)};
    ${(props) => (props.$isHeader ? 'min-height: 55px;' : 'min-height: 25px;')};
    ${(props) => (props.$isHeader ? 'padding-bottom: 30px;' : null)};
    ${(props) => (props.$isHeader ? 'cursor: default;' : 'cursor: pointer;')};
`;

// export const LinkUserPopupMenu = styled(Link)`
//     padding: 10px 5px;
// `;

export const LinkHeaderMenu = styled.a`
    display: flex;
    padding: 10px 0px 10px 8px;
    margin: 0px;
    align-items: center;
    justify-content: left;
    text-decoration: none;
    font-size: 14px;
    text-transform: uppercase;
    cursor: pointer;

    background-color: ${theme.app.secondary_alt};
    color: ${theme.app.backgroundColor};
    font-weight: ${theme.font.black};
`;

// export const LinkHeader = styled(Link)`
//     font-weight: ${theme.font.semi_bold};
// `;

export const Link_small = styled.a<{ $isHeader?: boolean }>`
    width: 33px;
    height: 57px;
    display: flex;
    align-items: center;
    cursor: pointer;

    /* padding: 13px 4px;  per icona normale */

    ${(props) =>
        props.$isHeader ? 'padding: 18px 4px 8px 4px;' : 'padding: 13px 4px;'} /* spostato un pò in basso per la freccia...togliere per icona normale  */

    :hover {
        filter: alpha(opacity=70);
        opacity: 0.7;
    }
`;

// ---------------------------------------------
type ContainerIconProps = {
    $isSelected?: boolean;
};

export const ContainerIcon = styled.div<ContainerIconProps>`
    width: 30px;
    height: 20px;

    min-width: 30px;
    min-height: 20px;
    padding-right: 10px;
    padding-left: 0px;
    color: ${(props) => (props.$isSelected ? theme.app.secondary : 'black')};
    svg {
        width: 20px;
        height: 20px;
        stroke: none;
        fill: ${(props) => (props.$isSelected ? theme.app.secondary : 'black')};
    }
    span {
        color: ${(props) => (props.$isSelected ? theme.app.secondary : 'black')};
    }
`;

export const ContainerIconHelp = styled(ContainerIcon)`
    > svg {
        fill: ${theme.app.backgroundColor};
    }
`;

export const ContainerIconSmall = styled.div<{ $isHeader?: boolean }>`
    width: 25px;
    height: 25px;

    > svg {
        /* fill: ${theme.app.primary};  */
        ${(props) => (props.$isHeader ? `fill: ${theme.app.secondary};` : `fill: ${theme.app.primary};`)}
    }
`;

export const ContainerArrow = styled.div<{ $isHidden?: boolean }>`
    width: 13px;
    height: 13px;
    position: absolute;
    top: 6px;
    right: 3px;
    ${(props) => (props.$isHidden ? 'visibility: visible;' : 'visibility: hidden;')}
    svg {
        stroke: white;
    }
`;

// Tooltip
export const ContainerTooltip = styled.div`
    position: relative;
    width: 16px;
    height: 16px;

    min-width: 16px;
    min-height: 16px;
    margin-left: 7px;

    svg {
        width: 16px;
        height: 16px;
    }
`;
export const TitleAndTooltipContainer = styled.div`
    display: grid;
    align-items: center;
    grid-template-columns: max-content 15px;
    gap: 5px;
    max-height: 15px;
    div {
        height: 15px;
        width: 15px;
    }
    svg {
        height: 15px;
        width: 15px;
        color: ${(props) => props.theme.app.secondary};
    }
`;
export const ContainerTooltipIcon = styled.div`
    position: absolute;
    top: 0px;
    width: 16px;
    height: 16px;
`;

export const TooltipStyled = styled.div`
    background-color: red;
`;

export const Container3Point = styled.div`
    width: 13px;
    height: 13px;
    position: absolute;
    top: 13px;
    left: 231px;
`;

// Sezione Subscription ________________________________________________
export const TextDayTrial = styled.div`
    padding: 3px;

    color: ${theme.app.primary};
    font-weight: ${theme.font.bold};
    font-size: 40px;
    text-transform: uppercase;
`;

export const ContainerTextSubscribe = styled.div`
    display: flex;
    padding: 5px;
    flex-direction: column;
    justify-content: center;
`;

export const ContainerSubscription = styled.div`
    display: flex;
    cursor: pointer;
    align-items: center;
`;

export const TextSubscribe = styled.text`
    color: ${theme.app.secondary};
    font-weight: ${theme.font.bold};
    font-size: 13px;
`;

export const ImgArrowRight = styled.div`
    margin-left: 5px;
`;

// Sezione Bottom Menu / User Menu

export const ConatinerMenuBottom = styled.div`
    position: relative;
`;

// PopUp UserMenu
export const ContanierUserMenu = styled.div<{ $isVisible: boolean }>`
    position: absolute;
    top: -180px;
    left: 180px;
    width: 260px;
    height: 268px;
    z-index: 10000;

    ${(props) => (props.$isVisible ? null : 'display: none')};

    border-radius: 10px;
    padding: 20px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    background-color: ${theme.app.backgroundColor};

    color: ${theme.app.primary};
    font-weight: ${theme.font.bold};
`;

export const ItemPopupMenu = styled.div`
    padding: 5px;

    & > :first-child {
        padding-bottom: 20px;
        border-bottom: dotted 1px grey;
    }

    & > :last-child {
        padding-top: 20px;
        border-top: dotted 1px grey;
    }
`;

// PopUp LanguageMenu
export const ContanierLanguageMenu = styled.div<{ $isVisible: boolean }>`
    position: absolute;
    top: -160px;
    left: 180px;
    width: 250px;
    height: 230px;
    z-index: 10000;

    ${(props) => (props.$isVisible ? null : 'display: none')};

    border-radius: 10px;
    padding: 25px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    background-color: ${theme.app.backgroundColor};

    color: ${theme.app.primary};
    font-weight: ${theme.font.bold};
`;

export const ItemLanguagePopupMenu = styled.div`
    padding: 5px;
    overflow-y: auto;
    height: 180px;

    ::-webkit-scrollbar {
        width: 3px;
    }
    ::-webkit-scrollbar-track {
        background: ${theme.app.backgroundColor};
        border-radius: 20px;
    }
    ::-webkit-scrollbar-thumb {
        background: ${theme.app.secondary};
        border-radius: 20px;
    }

    scrollbar-color: ${theme.app.secondary} ${theme.app.backgroundColor};
    scrollbar-width: thin;
`;

export const ContainerNotification = styled.div`
    position: absolute;
    top: -5px;
    left: 8px;
`;

export const ContainerConfigurator = styled.div`
    position: relative;
    background-color: ${theme.app.secondary};
    color: ${theme.app.backgroundColor};
    padding: 17px 38px 17px 15px;

    font-weight: ${theme.font.bold};
    font-size: 14px;
    text-transform: uppercase;
    cursor: pointer;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const ImgArrowRightWhite = styled.div`
    width: 20px;
    height: 20px;
    padding-left: 8px;
    position: absolute;
    top: 20px;
    right: 20px;
`;

// Banner Composer
export const ContanierComposerBanner = styled.div`
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: ${theme.app.secondary};
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    z-index: 11;
    height: 51px;
    /* text-transform: uppercase; */

    color: ${theme.app.backgroundColor};
    font-weight: ${theme.font.bold};
    font-size: 14px;
`;

export const ImgArrowRightWhiteComposer = styled.div`
    padding: 0px 10px;
`;

export const SwitchComposer = styled.div`
    border: none;
    border-radius: 30px;
    padding: 12px 40px;
    text-transform: uppercase;
    justify-content: center;
    cursor: pointer;

    background-color: ${theme.app.backgroundColor};
    color: ${theme.app.secondary};
    font-weight: ${theme.font.bold};
    font-size: 14px;
`;

export const LinkComposer = styled.a`
    /* background-color: ${theme.app.backgroundColor}; */
    color: ${theme.app.backgroundColor};
    font-weight: ${theme.font.bold};
    font-size: 14px;
    padding-left: 20px;
    text-decoration: underline;
`;

export const CloseComposerBanner = styled.div`
    width: 25px;
    height: 25px;
    padding-left: 8px;
    position: absolute;
    top: 18px;
    right: 25px;
    cursor: pointer;

    > svg {
        fill: ${theme.app.backgroundColor};
    }
`;

export enum ToDoListTask {
    Signup = 1,
    StartFreeTrial = 2,
    CreateFirstProduct = 3,
    ConnectYourStore = 4,
    PlaceTestOrder = 5
}
